const baseURL = 'https://florentinaaccesories.algorix.com.ar/';

export default baseURL;
